/*
  Вторая колонка шапки счёта: где дело и чем оно живёт — §3.3.5.

  Дорога взыскания сверху вниз с отметкой, где счёт сейчас, под ней опорные
  даты. Заведена 25.09.2026: до неё стадия стояла плиткой из двух слов («в
  норме»), и человек не видел ни пройденного пути, ни того, что будет дальше.

  🔴 Ни одного слова кабинет здесь не сочиняет. Заголовки шагов, подписи дат и
  их значения приходят готовыми из `account_summary_service` - кабинет решает
  только, как их показать: какой шаг отметить, какую дату выделить. Свой
  справочник разошёлся бы с сервером при первой правке (§4.5.1).
*/

import InfoHint from './InfoHint.jsx'

const ROAD_HINT =
  'Дорога показана основная. У неё есть ветвления, которых здесь не видно, пока ' +
  'дело на них не свернуло: рассрочка, отменённый приказ, исковое производство, ' +
  'исключение из взыскания. Свернувший счёт показывает свой шаг сам.'

export default function AccountRoad({ summary }) {
  return (
    <div className="summary__col summary__col--tinted">
      <div className="summary__cap">
        Как движется дело
        <InfoHint title="Что за дорога" text={ROAD_HINT} />
      </div>

      <ol className="road">
        {summary.road.map((step) => (
          <li key={step.stage} className={`road__step${stepKind(step)}`}>
            {step.title}
            {/*
              День, когда шаг пройден, приходит из смен стадий и только оттуда.
              У счёта, заведённого сразу в поздней стадии, дат у ранних шагов
              нет - и тогда строки нет тоже, а не «дата неизвестна».
            */}
            {step.note ? <span className="road__note">{step.note}</span> : null}
          </li>
        ))}
      </ol>

      <div className="dates">
        {summary.dates.map((item) => (
          <div className="dates__row" key={item.title}>
            <span className="dates__title">{item.title}</span>
            {/*
              Выделяет сервер, а не кабинет: близость срока считается от
              сегодняшнего дня там же, где собрана сама дата. Янтарный означает
              здесь ровно то же, что везде, - «скоро потребуется действие».
            */}
            <b className={`dates__value${item.soon ? ' dates__value--soon' : ''}`}>{item.value}</b>
          </div>
        ))}
      </div>
    </div>
  )
}

/* Вид шага: пройден, идёт сейчас или ещё впереди. */
function stepKind(step) {
  if (step.is_now) return ' road__step--now'
  return step.passed ? ' road__step--passed' : ''
}
